import { z } from "zod";

import {
  UploadAttachResponseDTOError,
  UploadAttachResponseDTOSuccess,
} from "../models/UploadAttach.response.dto";

export const isError = (
  response: unknown,
): response is z.infer<typeof UploadAttachResponseDTOError> => {
  return UploadAttachResponseDTOError.safeParse(response).success;
};

export const isSuccess = (
  response: unknown,
): response is z.infer<typeof UploadAttachResponseDTOSuccess> => {
  return UploadAttachResponseDTOSuccess.safeParse(response).success;
};
